module.exports = __webpack_public_path__ + "img/pen-suit (4).af0f4c81.png";